module.exports = __webpack_public_path__ + "static/img/guide4.a1c7e176.png";